import { apiClient } from './client';

export interface WelcomeConfig {
  text: string | null;
  imageUrl: string | null;
}

export interface UpdateWelcomeBody {
  text?: string;
  imageUrl?: string;
}

export const welcomeApi = {
  get: async (): Promise<WelcomeConfig> => {
    const { data } = await apiClient.get('/admin/welcome');
    return data as WelcomeConfig;
  },

  update: async (body: UpdateWelcomeBody): Promise<{ ok: true }> => {
    const { data } = await apiClient.put('/admin/welcome', body);
    return data as { ok: true };
  },

  uploadImage: async (file: File): Promise<{ imageUrl: string }> => {
    const form = new FormData();
    form.append('file', file);
    const { data } = await apiClient.post('/admin/welcome/image', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data as { imageUrl: string };
  },
};
